module.exports = __webpack_public_path__ + "static/media/paid-stamp.576b23da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/paid-stamp.png
// module id = 1138
// module chunks = 2